/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Correct_Reading_SpeedInputs */



/**
* | output |
* | --- |
* | "Auto Correct Reading Speed" |
*
* @param {Auto_Correct_Reading_SpeedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_correct_reading_speed = /** @type {((inputs?: Auto_Correct_Reading_SpeedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Correct_Reading_SpeedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Correction auto de la vitesse de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lesegeschwindigkeit automatisch korrigieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correzione automatica della velocità di lettura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическая коррекция скорости чтения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corrección automática de velocidad de lectura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动校正阅读速度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動修正読み取り速度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वतः सुधार पठन गति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Correção automática da velocidade de leitura")
	return /** @type {LocalizedString} */ ("Auto Correct Reading Speed")
});